import { useIntl } from "react-intl"
import { Locale, TextDirection } from "#/types/Locale"

export const useTextDirection = (): TextDirection => {
  const { locale } = useIntl()
  return Locale.getLocaleFromString(locale).textDirection
}
